export const moreLink = {
  color: 'black',
}

export const showMeMore = {
  textAlign: 'right',
}
